export default "__VITE_ASSET__z8ZHeBr5__"